import React from "react";
import { Modal, Drawer, Button } from "antd";
import { useMediaQuery } from "usehooks-ts";
import { useTheme } from "../contexts/ThemeContext";

interface ResponsiveModalProps {
  open: boolean;
  onClose: () => void;
  onOk?: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  confirmLoading?: boolean;
  okDisabled?: boolean;
  width?: number | string;
  closable?: boolean;
  maskClosable?: boolean;
  centered?: boolean;
  type?: "modal" | "confirm";
  danger?: boolean;
  icon?: React.ReactNode;
}

const ResponsiveModal: React.FC<ResponsiveModalProps> = ({
  open,
  onClose,
  onOk,
  title,
  children,
  footer,
  okText = "تایید",
  cancelText = "انصراف",
  confirmLoading = false,
  okDisabled = false,
  width = 520,
  closable = true,
  maskClosable = true,
  centered = true,
  type = "modal",
  danger = false,
  icon,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { isDark } = useTheme();

  // Default footer for confirm type
  const defaultFooter = type === "confirm" || onOk ? (
    <div
      style={{
        display: "flex",
        gap: "8px",
        justifyContent: "flex-end",
        padding: isMobile ? "12px 0" : undefined,
      }}
    >
      <Button onClick={onClose}
        size="large"
        block>{cancelText}</Button>
      <Button
        type="primary"
        danger={danger}
        loading={confirmLoading}
        disabled={okDisabled}
        onClick={onOk}
        size="large"
        block
      >
        {okText}
      </Button>
    </div>
  ) : null;

  const finalFooter = footer !== undefined ? footer : defaultFooter;

  if (isMobile) {
    // Mobile: Bottom Sheet (Drawer)
    return (
      <Drawer
        placement="bottom"
        open={open}
        closeIcon={null}
        onClose={onClose}
        height="auto"
        title={
          title && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              {/* {icon && <span style={{ fontSize: "24px" }}>{icon}</span>} */}
              {title}
            </div>
          )
        }
        closable={closable}
        styles={{
          body: { paddingBottom: finalFooter ? 80 : 20, maxHeight: "80vh", overflowY: "auto" },
          footer: { borderTop: `none` },
        }}
        footer={
          finalFooter && (
            <div
              style={{
                position: "sticky",
                bottom: 0,
                left: 0,
                right: 0,
                // padding: "12px 16px",
                // borderTop: `1px solid ${isDark ? "#303030" : "#f0f0f0"}`,
                backgroundColor: isDark ? "#1f1f1f" : "#ffffff",
              }}
            >
              {finalFooter}
            </div>
          )
        }
        style={{
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
        }}
      >
        <div className="text-base">{children}</div>
      </Drawer>
    );
  }

  // Desktop: Regular Modal
  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={onOk}
      title={
        title && icon ? (
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "24px" }}>{icon}</span>
            {title}
          </div>
        ) : (
          title
        )
      }
      footer={finalFooter}
      confirmLoading={confirmLoading}
      width={width}
      closable={closable}
      maskClosable={maskClosable}
      centered={centered}
      styles={{
        body: {
          padding: 10,
          maxHeight: "calc(100vh - 200px)",
          overflowY: "auto",
        }
      }}
    >
      {children}
    </Modal>
  );
};

export default ResponsiveModal;

